export class UnknownTextbookError extends Error {
  constructor(msg = 'Unknown-textbook') {
    super(msg);
  }
}
